import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createdBy: null,
  listName: "",
  serviceLocation: "",
  category: "",
  subCategory: "",
  item: "",
  categoryId: null,
  subCategoryId: null,
  itemId: 0,
  Description: "",
  hourlyOffer: "",
  Package: {},
  Photo: [""],
  photoIds: "",
  Video: [""],
  videoIds: "",
  customDetails: {},
  dynamicCustomDetails: {},
  Phone: "",
  dialExtension: null,
  specialOffer: "",
  giftAmount: null,
  giftTitle: "",
  giftDescription: "",
  dealTerm: "",
  pdfListing: "",
  availableDays: [{ days: [], from: "", to: "" }],
  vendorAvailableDays: [{ days: [] }],
  officeHours: [{ days: [], from: "", to: "" }],
  ApplyAll: false,
  serviceId: null,
  additionalPeople: null,
  paypalEmail: "",
  dealItem: [],
  dealPackage: [],
  serviceSelectType: [],
  venueToCustomer: 0,
  customerToVenue: 0,
  similarLocalVendors: 0,
  mandate: false,
  itemsToDisplay: [],
  createdPackages: [],
  options: [],
  contractTerm: [
    {
      contractType: "",
      contractDetails: "",
    },
  ],
  Questions: null,
};

const ServiceInfoSlice = createSlice({
  name: "serviceInfo",
  initialState,
  reducers: {
    resetServiceInfo: (state) => initialState,
    setCreatedBy: (state, action) => {
      state.createdBy = action.payload;
    },
    setListName: (state, action) => {
      state.listName = action.payload;
    },
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    setSubCategory: (state, action) => {
      state.subCategory = action.payload;
    },
    setItem: (state, action) => {
      state.item = action.payload;
    },
    setCategoryId: (state, action) => {
      state.categoryId = action.payload;
    },
    setSubCategoryId: (state, action) => {
      state.subCategoryId = action.payload;
    },
    setItemId: (state, action) => {
      state.itemId = action.payload;
    },
    setDescription: (state, action) => {
      state.Description = action.payload;
    },
    setHourlyOffer: (state, action) => {
      state.hourlyOffer = action.payload;
    },
    setPackage: (state, action) => {
      state.Package = action.payload;
    },
    setPhoto: (state, action) => {
      state.Photo = Array.isArray(action.payload) ? action.payload : [""];
    },
    setPhotoIds: (state, action) => {
      state.photoIds = action.payload;
    },
    setVideo: (state, action) => {
      state.Video = action.payload;
    },
    setVideoIds: (state, action) => {
      state.videoIds = action.payload;
    },
    setCustomDetails: (state, action) => {
      state.customDetails = action.payload;
    },
    setDynamicCustomDetails: (state, action) => {
      state.dynamicCustomDetails = action.payload;
    },
    setPhone: (state, action) => {
      state.Phone = action.payload;
    },
    setDialExtension: (state, action) => {
      state.dialExtension = action.payload;
    },
    setSpecialOffer: (state, action) => {
      state.specialOffer = action.payload;
    },
    setGiftAmount: (state, action) => {
      state.giftAmount = action.payload;
    },
    setGiftTitle: (state, action) => {
      state.giftTitle = action.payload;
    },
    setGiftDescription: (state, action) => {
      state.giftDescription = action.payload;
    },
    setDealTerm: (state, action) => {
      state.dealTerm = action.payload;
    },
    setPdfListing: (state, action) => {
      state.pdfListing = action.payload;
    },
    setAvailableDays: (state, action) => {
      state.availableDays = action.payload;
    },
    setOfficeHours: (state, action) => {
      state.officeHours = action.payload;
    },
    setVendorAvailableDays: (state, action) => {
      state.vendorAvailableDays = action.payload;
    },
    setVendorUpdatedDates: (state, action) => {
      state.vendorUpdatedDates = action.payload;
    },
    setApplyAll: (state, action) => {
      state.ApplyAll = action.payload;
    },
    setServiceId: (state, action) => {
      state.serviceId = action.payload;
    },
    setAdditionalPeople: (state, action) => {
      state.additionalPeople = action.payload;
    },
    setPayPalEmail: (state, action) => {
      state.paypalEmail = action.payload;
    },
    setVenueToCustomer: (state, action) => {
      state.venueToCustomer = action.payload;
    },
    setCustomerToVenue: (state, action) => {
      state.customerToVenue = action.payload;
    },
    setSimilarLocalVendors: (state, action) => {
      state.similarLocalVendors = action.payload;
    },
    setServiceLocation: (state, action) => {
      state.serviceLocation = action.payload;
    },
    setDealItem: (state, action) => {
      state.dealItem = action.payload;
    },
    setDealPackage: (state, action) => {
      state.dealPackage = action.payload;
    },
    setServiceSelectType: (state, action) => {
      state.serviceSelectType = action.payload;
    },
    setContractTerm: (state, action) => {
      state.contractTerm = action.payload;
    },
    setQuestions: (state, action) => {
      state.Questions = action.payload;
    },
  },
});

export const {
  resetServiceInfo,
  setCreatedBy,
  setListName,
  setCategory,
  setSubCategory,
  setItem,
  setCategoryId,
  setSubCategoryId,
  setItemId,
  setDescription,
  setHourlyOffer,
  setPackage,
  setPhoto,
  setPhotoIds,
  setVideo,
  setVideoIds,
  setCustomDetails,
  setDynamicCustomDetails,
  setPhone,
  setDialExtension,
  setSpecialOffer,
  setGiftAmount,
  setGiftTitle,
  setGiftDescription,
  setDealTerm,
  setPdfListing,
  setAvailableDays,
  setOfficeHours,
  setVendorAvailableDays,
  setVendorUpdatedDates,
  setApplyAll,
  setServiceId,
  setAdditionalPeople,
  setPayPalEmail,
  setVenueToCustomer,
  setCustomerToVenue,
  setSimilarLocalVendors,
  setServiceLocation,
  setDealPackage,
  setDealItem,
  setServiceSelectType,
  setContractTerm,
  setQuestions,
} = ServiceInfoSlice.actions;

export default ServiceInfoSlice.reducer;
